import { Button } from "@/components/ui/button";
import { ProcessSettingsForm } from "@/components/admin/ProcessSettingsForm";
import { ScannerControls } from "@/components/admin/ScannerControls";
import { SystemStatusPanel } from "@/components/admin/SystemStatusPanel";
import { TenantList } from "@/components/admin/TenantList";
import { TrackerInspector } from "@/components/admin/TrackerInspector";

interface AdminPageProps {
  onBack: () => void;
}

/** AdminPage is the platform-admin-only landing at /admin. Renders
 *  every process-wide control that used to live inline in the
 *  dashboard's Settings sheet and ScannerPanel. Non-admin users
 *  never reach here — App.tsx redirects them on mount. */
export function AdminPage({ onBack }: AdminPageProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b bg-card">
        <div className="mx-auto max-w-[1600px] px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">taco · admin</h1>
            <p className="text-sm text-muted-foreground">
              Process-wide controls. Changes here affect every tenant.
            </p>
          </div>
          <Button variant="outline" size="sm" onClick={onBack}>
            ← Back to dashboard
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-[1600px] p-6 space-y-6">
        <SystemStatusPanel />
        <ScannerControls />
        <ProcessSettingsForm />
        <TenantList />
        <TrackerInspector />
      </main>
    </div>
  );
}
